var $4438748d9952e7c7$exports = {};
$4438748d9952e7c7$exports = {
    "dismiss": `Odbaci`
};


export {$4438748d9952e7c7$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
